import { createReducer, createActions } from 'reduxsauce'
import {
  failureFeedback,
  initialFeedback,
  requestFeedback,
  successFeedback
} from './utils'

const INITIAL_STATE = {
  feedback: initialFeedback(),
  acceptanceFeedback: initialFeedback(),
  consentType: null, // 'ACCEPTANCE' | 'SIGNATURE'
  documentUrl: null,
  shouldShowModal: false,
  acceptanceLoading: false,
  acceptanceError: null,
}

const { Types, Creators } = createActions(
  {
    checkConsentType: [],
    checkConsentTypeSuccess: ['data'],
    checkConsentTypeFailure: ['errors'],
    acceptCodeConductContract: [],
    acceptCodeConductContractSuccess: ['data'],
    acceptCodeConductContractFailure: ['errors'],
    checkCodeConductPermission: [],
    closeCodeConductModal: [],
    setShowCodeConductModal: ['shouldShow'],
    clear: [],
  },
  { prefix: 'CODE_CONDUCT_' }
)

// Check consent type actions
const checkConsentType = (state) => ({
  ...state,
  feedback: requestFeedback(),
  consentType: null,
  documentUrl: null,
})

const checkConsentTypeSuccess = (state, { data }) => ({
  ...state,
  feedback: successFeedback(),
  consentType: data.consentType,
  documentUrl: data.documentUrl || null,
})

const checkConsentTypeFailure = (state, { errors }) => ({
  ...state,
  feedback: failureFeedback(errors),
  consentType: null,
  documentUrl: null,
})

// Accept contract actions
const acceptCodeConductContract = (state) => ({
  ...state,
  acceptanceFeedback: requestFeedback(),
  acceptanceLoading: true,
  acceptanceError: null,
})

const acceptCodeConductContractSuccess = (state) => ({
  ...state,
  acceptanceFeedback: successFeedback(),
  acceptanceLoading: false,
  acceptanceError: null,
  shouldShowModal: false, // Hide modal on successful acceptance
})

const acceptCodeConductContractFailure = (state, { errors }) => ({
  ...state,
  acceptanceFeedback: failureFeedback(errors),
  acceptanceLoading: false,
  acceptanceError: errors,
})

// Modal visibility actions
const closeCodeConductModal = (state) => ({
  ...state,
  shouldShowModal: false,
})

const setShowCodeConductModal = (state, { shouldShow }) => ({
  ...state,
  shouldShowModal: shouldShow,
})

const clear = () => INITIAL_STATE

export const CodeConductActionTypes = Types

const HANDLERS = {
  [Types.CHECK_CONSENT_TYPE]: checkConsentType,
  [Types.CHECK_CONSENT_TYPE_SUCCESS]: checkConsentTypeSuccess,
  [Types.CHECK_CONSENT_TYPE_FAILURE]: checkConsentTypeFailure,
  [Types.ACCEPT_CODE_CONDUCT_CONTRACT]: acceptCodeConductContract,
  [Types.ACCEPT_CODE_CONDUCT_CONTRACT_SUCCESS]: acceptCodeConductContractSuccess,
  [Types.ACCEPT_CODE_CONDUCT_CONTRACT_FAILURE]: acceptCodeConductContractFailure,
  [Types.CLOSE_CODE_CONDUCT_MODAL]: closeCodeConductModal,
  [Types.SET_SHOW_CODE_CONDUCT_MODAL]: setShowCodeConductModal,
  [Types.CLEAR]: clear,
}

export const CodeConductActionCreators = Creators

export default createReducer(INITIAL_STATE, HANDLERS)
